import { render } from "./FarmOSGroupSettings.vue?vue&type=template&id=2d6e89f6&scoped=true"
import script from "./FarmOSGroupSettings.vue?vue&type=script&lang=js"
export * from "./FarmOSGroupSettings.vue?vue&type=script&lang=js"

import "./FarmOSGroupSettings.vue?vue&type=style&index=0&id=2d6e89f6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6e89f6"]])

export default __exports__